export default __webpack_public_path__ + "static/media/outdoorrowing.f1c64b1e.png";